import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface redirectState {
    // redirect
    app?: string | null;
    store_id?: string | null;
}

const useRedirect = create<redirectState>()(
    persist(
        (set) => ({
            app: null,
            store_id: null,
        }),
        { name: "redirectCache", storage: createJSONStorage(() => sessionStorage) }
    )
);

export default useRedirect;
